import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import axios from "axios";
import * as moment from "moment";
import {
  Dialog,
  Button,
  RadioButton,
  Dropdown,
  TextInput,
  DropdownWithSearch,
  CustomCheckBox,
  Image,
} from "hesus-ui-kit";
import DatePicker from "react-multi-date-picker";
import ClipLoader from "react-spinners/ClipLoader";
import { Tooltip } from "react-tooltip";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import { enquiryDocumentTypes } from "@utils/constants";
import UserInfo from "@utils/UserInfo";
import { updateUnitTranslation } from "@utils/utils";
import {
  getDatePickerFormat,
  getDateFormat,
  getCalendarLocale,
} from "@utils/datePickerUtils";
import AddressSearch from "../../../components/AddressSearch";
import DocumentUploadWithType from "@components/DocumentUpload/DocumentUploadWithType";
import lowIcon from "@icons/ic-priority-low.svg";
import normalIcon from "@icons/ic-priority-normal.svg";
import highIcon from "@icons/ic-priority-high.svg";
import unknownIcon from "@icons/ic-priority-unknown.svg";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";

import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
  RequiredMessagePara,
  DivToolTip,
} from "@utils/extra-style";

import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OuterWrapper,
  FlexRow,
  SectionContainer,
  GridRow,
  ContainerLabel,
  MarginDiv,
  DueDateSpan,
} from "./AddEditEnquiry.styled";
import "./AddEditEnquiry.scss";
import closeIcon from "@icons/ic-close-white.svg";

const AddEditEnquiry = (props) => {
  const {
    t,
    id,
    isEditMode,
    title,
    onClose,
    updateRefeshStatus,
    siteId,
    platformCountryId,
    enquiryData,
    leadId,
  } = props;
  const [isEnquiryCreating, setIsEnquiryCreating] = useState(false);
  const [createEnquiryAPIError, setCreateEnquiryAPIError] = useState("");
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [selectedEnquiry, setSelectedEnquiry] = useState(enquiryData);
  const [categoryId, setCategoryId] = useState(
    enquiryData?.product?.category?.id
  );
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [materialUsageList, setMaterialUsageList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [transportTypes, setTransportTypes] = useState([]);
  const [docType, setDocType] = useState([]);
  const [isEditStep, setIsEditStep] = useState(false);
  const [isEditPollutionStep, setIsEditPollutionStep] = useState(false);
  const EnquiryListByIds = useSelector((state) => state.enquiryList.byId);
  const fetchEnquiry = EnquiryListByIds[id];
  const stepStatus = [1, 2, 9];
  const stepPollutionStatus = [1, 2, 5, 9];

  const userInfo = UserInfo.getUser();
  let lowDate = new Date();
  let normalDate = new Date();
  let highDate = new Date();
  lowDate = lowDate.setDate(lowDate.getDate() + 5);
  normalDate = normalDate.setDate(normalDate.getDate() + 3);
  highDate = highDate.setDate(highDate.getDate() + 1);

  const generalParams = useGetGeneralParameters();
  const countries = generalParams?.countryList;

  const { unitList } = generalParams;
  useEffect(() => {
    if (
      fetchEnquiry !== undefined &&
      parseInt(id, 10) === parseInt(selectedEnquiry.id, 10)
    ) {
      setSelectedEnquiry(fetchEnquiry);
    }
    if (
      isEditMode &&
      stepStatus.indexOf(parseInt(enquiryData.step, 10)) === -1
    ) {
      setIsEditStep(true);
    }
    if (
      isEditMode &&
      stepPollutionStatus.indexOf(parseInt(enquiryData.step, 10)) === -1
    ) {
      setIsEditPollutionStep(true);
    }
  }, [fetchEnquiry, enquiryData]);

  const fetchSubCategories = () => {
    axios
      .get("/general/subCategories")
      .then((response) => {
        const subCategoryData = response.data.subCategories.map((subCat) => {
          return {
            label: t(subCat.category.name) + " - " + t(subCat.name),
            value: subCat.id,
            categoryId: subCat.category.id,
          };
        });
        setSubCategoryList(subCategoryData);
      })
      .catch((error) => {});
  };

  const fetchMaterialUages = () => {
    axios
      .get(`/general/materialUsages?countryId=${platformCountryId}`)
      .then((response) => {
        const usageData = response.data.materialUsage.map((usage) => {
          return {
            label: usage.name,
            value: String(usage.id),
          };
        });
        setMaterialUsageList(usageData);
      })
      .catch((error) => {});
  };

  const fetchTranports = () => {
    axios
      .get(
        `/transports?countries=[${platformCountryId}]&status=1&limit=-1&orderBy=asc&orderColumn=orderIndex&prefrence=no`
      )
      .then((response) => {
        const transportTypesLocal = response.data.transports.map(
          (transportTypeItem) => {
            return {
              label: transportTypeItem.name,
              value: transportTypeItem.id,
            };
          }
        );
        setTransportTypes(transportTypesLocal);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    fetchSubCategories();
    fetchTranports();
    fetchMaterialUages();
  }, []);

  const getFormTransports = (trucks) => {
    const transports = [];
    if (trucks !== undefined && trucks !== null && trucks.length) {
      trucks.map((transport) => {
        transports.push({
          value: transport.id,
          label: transport.name,
        });
      });
    }
    return transports;
  };

  const [formData, setFormData] = useState({
    service: {
      required: false,
      value: selectedEnquiry?.service ?? "EVACUATION",
      error: "",
    },
    priority: {
      required: false,
      value: selectedEnquiry?.priority ? selectedEnquiry?.priority : 3 ?? "",
      error: "",
    },
    subCategory: {
      required: false,
      value: selectedEnquiry?.subCategory?.id ?? "",
      error: "",
    },
    product: {
      required: false,
      value: {
        value: selectedEnquiry?.product?.id
          ? selectedEnquiry?.product?.id.toString()
          : "",
        label: selectedEnquiry?.product?.name ?? "",
      },
      error: "",
    },
    quantity: {
      required: false,
      value: selectedEnquiry?.quantity ?? "",
      error: "",
    },
    unit: {
      required: false,
      value: selectedEnquiry?.unit ?? "",
      error: "",
    },
    transports: {
      required: false,
      value: getFormTransports(selectedEnquiry?.trucks),
      error: "",
    },
    destination: {
      required: false,
      value: selectedEnquiry?.destination ?? "",
      error: "",
    },
    singleDate: {
      required: false,
      value: selectedEnquiry?.dateType === 1 ? true : false ?? false,
      error: "",
    },
    startDate: {
      required: true,
      value: selectedEnquiry?.startDate
        ? moment(selectedEnquiry.startDate).format("YYYY-MM-DD")
        : null,
      error: "",
    },
    endDate: {
      required: true,
      value: selectedEnquiry?.endDate
        ? moment(selectedEnquiry.endDate).format("YYYY-MM-DD")
        : null,
      error: "",
    },
    purchaseOrder: {
      required: false,
      value: selectedEnquiry?.purchaseOrder ?? "",
      error: "",
    },
    price: {
      required: false,
      value: selectedEnquiry?.price ?? "",
      error: "",
    },
    loadsPerDay: {
      required: false,
      value: selectedEnquiry?.loadsPerDay ?? "",
      error: "",
    },
    materialUsages: {
      value: {
        value: selectedEnquiry?.materialUsage?.id
          ? selectedEnquiry?.materialUsage?.id.toString()
          : "",
        label: selectedEnquiry?.materialUsage?.name ?? "",
      },
      error: "",
      required: true,
    },
    internalComment: {
      value: selectedEnquiry?.internalComment ?? "",
      error: "",
      required: true,
    },
    pollutionComment: {
      value: selectedEnquiry?.adminComment ?? "",
      error: "",
      required: true,
    },
    complementaryAnalysis: {
      value: selectedEnquiry?.analysis ?? "0",
      error: "",
      required: true,
    },
    isEligibleBackfilling: {
      required: false,
      value: selectedEnquiry?.isEligibleBackfilling ?? "",
      error: "",
    },
    step: {
      value: selectedEnquiry?.step ?? "",
      error: "",
      required: true,
    },
    documents: [],
  });

  const [internalComment, setInternalComment] = useState(
    selectedEnquiry?.internalComment ?? ""
  );
  const [pollutionComment, setPollutionComment] = useState(
    selectedEnquiry?.adminComment ?? ""
  );
  useEffect(() => {
    setFormData({
      ...formData,
      internalComment: {
        value: internalComment,
        error: "",
        required: true,
      },
    });
  }, [internalComment]);

  useEffect(() => {
    setFormData({
      ...formData,
      pollutionComment: {
        value: pollutionComment,
        error: "",
        required: true,
      },
    });
  }, [pollutionComment]);

  const onServiceSelect = (e) => {
    setFormData({
      ...formData,
      service: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onPrioritySelect = (priorityValue) => {
    if (
      !isEditMode ||
      (isEditMode && parseInt(selectedEnquiry.step, 10) === 1)
    ) {
      setFormData({
        ...formData,
        priority: {
          value: priorityValue,
          error: "",
          required: true,
        },
      });
    }
  };

  const onSubCategoryChange = (e) => {
    const subCategoryId = e.value;
    const catInfo = subCategoryList.find(
      ({ value }) => parseInt(value, 10) === parseInt(subCategoryId, 10)
    );
    setCategoryId(catInfo.categoryId);
    setFormData({
      ...formData,
      subCategory: {
        value: subCategoryId,
        error: "",
        required: true,
      },
      product: {
        value: "",
        error: "",
        required: true,
      },
    });
  };

  const onProductChange = (filter) => {
    setFormData({
      ...formData,
      product: {
        value: filter,
        error: "",
        required: true,
      },
    });
  };
  const onUsageChange = (filter) => {
    setFormData({
      ...formData,
      materialUsages: {
        value: filter,
        error: "",
        required: true,
      },
    });
  };

  const onQuantityChange = (e) => {
    setFormData({
      ...formData,
      quantity: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onUnitChange = (e) => {
    setFormData({
      ...formData,
      unit: {
        value: e.value,
        error: "",
        required: true,
      },
    });
  };
  const onTransportsChange = (filter) => {
    setFormData({
      ...formData,
      transports: {
        value: filter,
        error: "",
        required: true,
      },
    });
  };

  const onAddressSelect = (selectedAddress) => {
    const address = {
      street: selectedAddress.street.value,
      postalCode: selectedAddress.postal.value,
      city: selectedAddress.city.value,
      position: {
        latitude: selectedAddress.latitude.value,
        longitude: selectedAddress.longitude.value,
      },
    };
    setFormData({
      ...formData,
      destination: {
        value: address,
        error: "",
        required: true,
      },
    });
  };

  const onDateStatusChange = (e) => {
    const dateValue = e.target.checked;
    setFormData({
      ...formData,
      singleDate: {
        value: dateValue,
        error: "",
        required: true,
      },
    });
  };

  const onStartDateChange = (e) => {
    setFormData({
      ...formData,
      startDate: {
        value: moment(e.toDate()).format("YYYY-MM-DD"),
        error: "",
        required: true,
      },
    });
  };

  const onEndDateChange = (e) => {
    setFormData({
      ...formData,
      endDate: {
        value: moment(e.toDate()).format("YYYY-MM-DD"),
        error: "",
        required: true,
      },
    });
  };

  const onPurchaseOrderChange = (e) => {
    setFormData({
      ...formData,
      purchaseOrder: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onPriceChange = (e) => {
    setFormData({
      ...formData,
      price: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onLoadsPerDayChange = (e) => {
    setFormData({
      ...formData,
      loadsPerDay: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onComplementaryAnalysisChange = (e) => {
    setFormData({
      ...formData,
      complementaryAnalysis: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onEligibleBackfillingChange = (e) => {
    setFormData({
      ...formData,
      isEligibleBackfilling: {
        value: !formData.isEligibleBackfilling.value,
        error: "",
        required: true,
      },
    });
  };

  const getCountryName = (selectedCountryId) => {
    if (selectedCountryId) {
      const isCountryPresent = countries.find(
        ({ id }) => id === selectedCountryId
      );
      if (isCountryPresent) {
        return isCountryPresent.label;
      }
    }
    return "";
  };

  const fetchProducts = (subCategory) => {
    axios
      .get(
        `/products?status=1&subCategories=[${subCategory}]&countries=${platformCountryId}&orderBy=asc&limit=-1`
      )
      .then((response) => {
        const productData = response.data.products.map((product) => {
          return {
            label: product.name,
            value: String(product.id),
          };
        });
        setProductList(productData);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (formData.subCategory.value !== "")
      fetchProducts(formData.subCategory.value);
  }, [formData.subCategory.value]);

  const validateForm = (data) => {
    let isFormValid = true;
    if (!data.service.value) {
      isFormValid = false;
      data.service.error = t("FIELD_REQUIRED");
    }
    if (!data.priority.value) {
      isFormValid = false;
      data.priority.error = t("FIELD_REQUIRED");
    }
    if (!data.subCategory.value) {
      isFormValid = false;
      data.subCategory.error = t("FIELD_REQUIRED");
    }
    if (!data.product.value?.value) {
      isFormValid = false;
      data.product.error = t("FIELD_REQUIRED");
    }
    if (!data.quantity.value) {
      isFormValid = false;
      data.quantity.error = t("FIELD_REQUIRED");
    }
    if (!data.unit.value) {
      isFormValid = false;
      data.unit.error = t("FIELD_REQUIRED");
    }
    if (data.price.value && !/^-?\d*[.,]?\d{0,2}$/.test(data.price.value)) {
      isFormValid = false;
      data.price.error = t("GENERAL_FORMAT_ERROR");
    }
    if (parseInt(categoryId, 10) === 4) {
      if (!data.destination.value) {
        isFormValid = false;
        data.destination.error = t("FIELD_REQUIRED");
      }
      if (
        data.loadsPerDay.value &&
        !/^-?\d*[.,]?\d{0,2}$/.test(data.loadsPerDay.value)
      ) {
        isFormValid = false;
        data.loadsPerDay.error = t("GENERAL_FORMAT_ERROR");
      }
    }
    if (parseInt(categoryId, 10) === 2) {
      if (data.price.value && !/^-?\d*[.,]?\d{0,2}$/.test(data.price.value)) {
        isFormValid = false;
        data.price.error = t("GENERAL_FORMAT_ERROR");
      }
    }
    if (data.transports.value.length === 0) {
      isFormValid = false;
      data.transports.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!data.startDate.value) {
      isFormValid = false;
      data.startDate.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!isFormValid) {
      setFormData({ ...data });
    }
    return isFormValid;
  };

  const getFormData = () => {
    const transportArray = [];
    if (formData.transports.value.length) {
      formData.transports.value.map((transport) => {
        transportArray.push({
          id: transport.value,
          name: transport.label,
        });
      });
    }

    const dataModified = new FormData();
    dataModified.append("id", id);
    dataModified.append(
      "site",
      JSON.stringify({
        id: siteId,
      })
    );
    dataModified.append("isActive", true);
    dataModified.append("service", formData.service.value);
    dataModified.append("quantity", formData.quantity.value);
    dataModified.append("unit", formData.unit.value);
    dataModified.append("requestedPrice", formData.price.value);
    dataModified.append("product", formData.product.value.value);
    if (parseInt(platformCountryId, 10) === 1) {
      dataModified.append("purchaseOrder", formData.purchaseOrder.value);
    }
    dataModified.append(
      "product",
      JSON.stringify({
        id: formData.product.value.value,
        name: formData.product.value.label,
        subCategory: {
          id: formData.subCategory.value,
        },
        country: {
          id: platformCountryId,
        },
      })
    );
    dataModified.append("loadsPerDay", formData.loadsPerDay.value);
    dataModified.append(
      "isEligibleBackfilling",
      formData.isEligibleBackfilling.value ? 1 : 0
    );
    if (formData.priority.value === 3)
      dataModified.append("dueDate", moment(lowDate).format("YYYY-MM-DD"));
    if (formData.priority.value === 2)
      dataModified.append("dueDate", moment(normalDate).format("YYYY-MM-DD"));
    if (formData.priority.value === 1)
      dataModified.append("dueDate", moment(highDate).format("YYYY-MM-DD"));

    dataModified.append("priority", formData.priority.value);

    dataModified.append(
      "destination",
      JSON.stringify(formData.destination.value)
    );
    if (parseInt(categoryId, 10) === 4) {
      dataModified.append("dateType", formData.singleDate.value ? 1 : 2);
    }
    if (parseInt(categoryId, 10) !== 4) {
      dataModified.append("dateType", 2);
    }
    dataModified.append("startDate", formData.startDate.value);
    dataModified.append(
      "endDate",
      formData.endDate.value ? formData.endDate.value : formData.startDate.value
    );
    dataModified.append(
      "complementaryAnalysis",
      formData.complementaryAnalysis.value
    );
    dataModified.append("internalComment", formData.internalComment.value);
    dataModified.append("pollutionComment", formData.pollutionComment.value);
    dataModified.append("transports", JSON.stringify(transportArray));
    dataModified.append("materialUsage", formData.materialUsages.value.value);

    if (formData.documents.length > 0) {
      for (let i = 0; i < formData.documents.length; i++) {
        dataModified.append(`document[${i}][type][id]`, docType[i]);
        dataModified.append(
          `document[${i}][filename]`,
          formData.documents[i].name
        );
        dataModified.append(`document[${i}][file]`, formData.documents[i]);
      }
    }
    if (existingDocuments !== undefined && existingDocuments.length > 0) {
      let i = formData.documents.length > 0 ? formData.documents.length : 0;
      existingDocuments.forEach((document) => {
        dataModified.append(`document[${i}][filename]`, document.fileName);
        dataModified.append(`document[${i}][id]`, document.id);
        dataModified.append(`document[${i}][file]`, document.fileName);
        i += 1;
      });
    }

    if (leadId && !isEditMode) {
      dataModified.append("leadRequestId", enquiryData?.id);
      dataModified.append("leadId", leadId);
    }
    dataModified.append("createdBy", userInfo.id);
    return dataModified;
  };
  const onSubmit = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      const data = getFormData(formData);
      setIsEnquiryCreating(true);
      setCreateEnquiryAPIError("");
      // Create solution
      if (!id && !isEditMode) {
        axios
          .post(`/enquiries`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            setIsEnquiryCreating(false);
            updateRefeshStatus();
            onClose();
          })
          .catch((error) => {
            setIsEnquiryCreating(false);
            setCreateEnquiryAPIError(error.response?.data?.message ?? "");
          });
      }
      // on Edit
      if (id && isEditMode) {
        axios
          .post(`/enquiries/${id}`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            setIsEnquiryCreating(false);
            onClose();
            updateRefeshStatus();
          })
          .catch((error) => {
            setIsEnquiryCreating(false);
            setCreateEnquiryAPIError(error.response?.data?.message ?? "");
          });
      }
    }
  };
  return (
    <Dialog>
      <div className="add-edit-enquiry">
        <HeaderWrapper>
          <Title>
            {title} {id ? "#" + id : ""}
          </Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close Enquiry price popup"
              className="add-enquiry__image-icon"
            />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OuterWrapper>
            <FlexRow>
              <SectionContainer>
                <div>
                  <GridRow column="1fr 1fr">
                    <div
                      className={
                        formData.service.error === ""
                          ? "add-enquiry__title"
                          : "add-enquiry__title_error"
                      }
                    >
                      <ContainerLabel
                        htmlFor="OPERATION"
                        labelStyles={
                          formData.service.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                      >
                        {t("OPERATION")}
                      </ContainerLabel>
                      <RadioButton
                        value={formData.service.value}
                        onChange={onServiceSelect}
                        name="price-type"
                        disabled={isEditStep}
                        options={[
                          {
                            label: t("REMOVAL"),
                            value: "EVACUATION",
                          },
                          { label: t("SUPPLY"), value: "DELIVERY" },
                          { label: t("OTHER"), value: "NONE" },
                        ]}
                      />
                      {formData.service.error && (
                        <RequiredMessagePara margin="-20px 0 0 10px">
                          {formData.service.error}
                        </RequiredMessagePara>
                      )}
                    </div>
                    <div
                      className={
                        formData.priority.error === ""
                          ? "add-enquiry__title"
                          : "add-enquiry__title_error"
                      }
                    >
                      <ContainerLabel
                        htmlFor="ENQUIRY_PRIORITY"
                        labelStyles={
                          formData.priority.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                      >
                        {t("ENQUIRY_PRIORITY")}
                      </ContainerLabel>
                      <GridRow column="1fr">
                        <div>
                          <Image
                            src={
                              formData.priority.value !== 3
                                ? unknownIcon
                                : lowIcon
                            }
                            alt={t("LOW")}
                            title={t("LOW")}
                            className="add-enquiry__image-icon"
                            onClick={() => onPrioritySelect(3)}
                            id={`enquiry-low-tooltip-id${siteId}`}
                          />
                          <Tooltip
                            anchorSelect={`#enquiry-low-tooltip-id${siteId}`}
                            style={DivToolTip}
                            content={
                              t("TOOLTIP_ENQUIRY_PRIORITY_LOW") +
                              " " +
                              getDateFormat(
                                moment(lowDate).format("YYYY-MM-DD"),
                                "YYYY-MM-DD"
                              )
                            }
                          />

                          <Image
                            src={
                              formData.priority.value !== 2
                                ? unknownIcon
                                : normalIcon
                            }
                            alt={t("NORMAL")}
                            title={t("NORMAL")}
                            className="add-enquiry__image-icon"
                            onClick={() => onPrioritySelect(2)}
                            id={`enquiry-normal-tooltip-id${siteId}`}
                          />
                          <Tooltip
                            anchorSelect={`#enquiry-normal-tooltip-id${siteId}`}
                            style={DivToolTip}
                            content={
                              t("TOOLTIP_ENQUIRY_PRIORITY_NORMAL") +
                              " " +
                              getDateFormat(
                                moment(normalDate).format("YYYY-MM-DD"),
                                "YYYY-MM-DD"
                              )
                            }
                          />

                          <Image
                            src={
                              formData.priority.value !== 1
                                ? unknownIcon
                                : highIcon
                            }
                            alt={t("HIGH")}
                            title={t("HIGH")}
                            className="add-enquiry__image-icon"
                            onClick={() => onPrioritySelect(1)}
                            id={`enquiry-high-tooltip-id${siteId}`}
                          />
                          <Tooltip
                            anchorSelect={`#enquiry-high-tooltip-id${siteId}`}
                            style={DivToolTip}
                            content={
                              t("TOOLTIP_ENQUIRY_PRIORITY_HIGH") +
                              " " +
                              getDateFormat(
                                moment(highDate).format("YYYY-MM-DD"),
                                "YYYY-MM-DD"
                              )
                            }
                          />
                          {formData.priority.value === 3 && (
                            <DueDateSpan color="#32A728">
                              {t("ENQUIRY_TURNAROUND_MESSAGE") +
                                " " +
                                getDateFormat(
                                  moment(lowDate).format("YYYY-MM-DD"),
                                  "YYYY-MM-DD"
                                )}
                            </DueDateSpan>
                          )}
                          {formData.priority.value === 2 && (
                            <DueDateSpan color="#F08046">
                              {t("ENQUIRY_TURNAROUND_MESSAGE") +
                                " " +
                                getDateFormat(
                                  moment(normalDate).format("YYYY-MM-DD"),
                                  "YYYY-MM-DD"
                                )}
                            </DueDateSpan>
                          )}
                          {formData.priority.value === 1 && (
                            <DueDateSpan color="#E83F1E">
                              {t("ENQUIRY_TURNAROUND_MESSAGE") +
                                " " +
                                getDateFormat(
                                  moment(highDate).format("YYYY-MM-DD"),
                                  "YYYY-MM-DD"
                                )}
                            </DueDateSpan>
                          )}
                          {formData.priority.error && (
                            <RequiredMessagePara>
                              {formData.priority.error}
                            </RequiredMessagePara>
                          )}
                        </div>
                      </GridRow>
                    </div>
                  </GridRow>
                  <GridRow column="1fr 1fr">
                    <div className="add-enquiry__dropdownunit">
                      <Dropdown
                        id="sub-category"
                        label={t("SUB_CATEGORY")}
                        name="addEnquirySubCategory"
                        value={formData.subCategory.value}
                        onChange={onSubCategoryChange}
                        defaultOption={t("SUB_CATEGORY")}
                        options={subCategoryList}
                        disabled={isEditStep}
                        labelStyles={
                          formData.subCategory.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.subCategory.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        required
                        error={formData.subCategory.error}
                      />
                    </div>
                    <div className="add-enquiry__dropdown">
                      <DropdownWithSearch
                        placeholder={t("PRODUCT")}
                        label={t("PRODUCT")}
                        value={formData.product.value}
                        options={productList}
                        disabled={isEditStep}
                        required
                        isMulti={false}
                        error={formData.product.error}
                        onChange={onProductChange}
                        labelStyles={
                          formData.product.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputClass={
                          formData.product.error !== ""
                            ? "dropdown-with-search__dropdown-input-error"
                            : "dropdown-with-search__dropdown-input"
                        }
                      />
                    </div>
                  </GridRow>
                  <GridRow column="1fr 1fr 1fr">
                    <TextInput
                      id="add-enquiry-quantity"
                      type="text"
                      label={t("QUANTITY")}
                      isFloat
                      disabled={isEditStep}
                      value={String(formData.quantity.value)}
                      onChange={(e) => onQuantityChange(e)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.quantity.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.quantity.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      required
                      error={formData.quantity.error}
                      placeholder={t("QUANTITY")}
                    />
                    <div className="add-enquiry__dropdownunit">
                      <Dropdown
                        id="add-enquiry-unit"
                        label={t("UNIT")}
                        name="unit"
                        disabled={isEditStep}
                        value={formData.unit.value}
                        onChange={onUnitChange}
                        defaultOption={t("UNIT")}
                        options={updateUnitTranslation(unitList, t)}
                        labelStyles={
                          formData.unit.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.unit.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        required
                        error={formData.unit.error}
                      />
                    </div>
                    <DropdownWithSearch
                      placeholder={t("TRANSPORT_TYPES")}
                      label={t("TRANSPORT_TYPES")}
                      value={
                        formData.transports?.value.length > 0
                          ? formData.transports?.value
                          : ""
                      }
                      disabled={isEditStep}
                      options={transportTypes}
                      required
                      isMulti
                      error={formData.transports.error}
                      onChange={onTransportsChange}
                      labelStyles={
                        formData.transports.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputClass={
                        formData.transports.error !== ""
                          ? "dropdown-with-search__dropdown-input-error"
                          : "dropdown-with-search__dropdown-input"
                      }
                    />
                  </GridRow>
                  {parseInt(categoryId, 10) === 4 && (
                    <>
                      <GridRow column="1fr">
                        <>
                          <AddressSearch
                            title="DESTINATION"
                            disabled={isEditStep}
                            countryId={platformCountryId}
                            name={formData.destination}
                            language={localStorage.getItem("locale")}
                            onAddressSelect={onAddressSelect}
                            defaultAddress={
                              isEditMode
                                ? formData.destination.value?.street +
                                  " " +
                                  formData.destination.value?.postalCode +
                                  " " +
                                  formData.destination.value?.city +
                                  " " +
                                  (formData.destination.value?.country
                                    ? getCountryName(
                                        formData.destination.value.country
                                      )
                                    : "")
                                : ""
                            }
                          />
                        </>
                      </GridRow>
                      <GridRow column="1fr">
                        <CustomCheckBox
                          disabled={isEditStep}
                          id="enquiry-single-date-1"
                          labelText={t("ENQUIRY_SINGLE_DATE")}
                          dataId="enquiry-single-date-1"
                          onChange={(e) => {
                            onDateStatusChange(e);
                          }}
                          checked={formData.singleDate.value}
                        />
                      </GridRow>
                    </>
                  )}
                  <GridRow column="1fr 1fr 1fr">
                    <div
                      className={
                        formData.startDate.error
                          ? "add-enquiry__date-container_start_error"
                          : "add-enquiry__date-container_start add-enquiry__date-container_start_required"
                      }
                    >
                      <label htmlFor="winning-date">
                        {t("ESTIMATED_START_DATE")}
                      </label>
                      <DatePicker
                        disabled={isEditStep}
                        inputClass={
                          formData.startDate.error
                            ? "add-enquiry__date-input-error"
                            : "add-enquiry__date-input"
                        }
                        containerClassName="add-enquiry__datepicker-container"
                        type="text"
                        label={t("ESTIMATED_START_DATE")}
                        name="add-enquiry-start-date"
                        id="add-enquiry-start-date"
                        calendarPosition="bottom-center"
                        isFloat
                        onChange={onStartDateChange}
                        format={getDatePickerFormat()}
                        locale={getCalendarLocale()}
                        value={
                          getDateFormat(
                            formData.startDate.value,
                            "YYYY-MM-DD"
                          ) || ""
                        }
                        containerStyles={{ marginTop: "21px" }}
                        labelStyles={
                          formData.startDate.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        required
                        error={formData.startDate.error}
                        placeholder={t("ESTIMATED_START_DATE")}
                      />
                      {formData.startDate.error && (
                        <RequiredMessagePara>
                          {formData.startDate.error}
                        </RequiredMessagePara>
                      )}
                    </div>

                    {(parseInt(categoryId, 10) !== 4 ||
                      (parseInt(categoryId, 10) === 4 &&
                        !formData.singleDate.value)) && (
                      <div
                        className={
                          formData.endDate.error
                            ? "add-enquiry__date-container_start_error"
                            : "add-enquiry__date-container_start"
                        }
                      >
                        <label htmlFor="winning-date">
                          {t("ESTIMATED_END_DATE")}
                        </label>
                        <DatePicker
                          disabled={isEditStep}
                          inputClass={
                            formData.endDate.error
                              ? "add-enquiry__date-input-error"
                              : "add-enquiry__date-input"
                          }
                          containerClassName="add-enquiry__datepicker-container"
                          type="text"
                          label={t("ESTIMATED_END_DATE")}
                          name="add-enquiry-start-date"
                          id="add-enquiry-start-date"
                          calendarPosition="bottom-center"
                          isFloat
                          onChange={onEndDateChange}
                          format={getDatePickerFormat()}
                          locale={getCalendarLocale()}
                          value={
                            getDateFormat(
                              formData.endDate.value,
                              "YYYY-MM-DD"
                            ) || ""
                          }
                          containerStyles={{ marginTop: "21px" }}
                          labelStyles={
                            formData.endDate.error !== ""
                              ? labelStylesError
                              : labelStyles
                          }
                          required
                          error={formData.endDate.error}
                          placeholder={t("ESTIMATED_END_DATE")}
                        />
                        {formData.endDate.error && (
                          <RequiredMessagePara>
                            {formData.endDate.error}
                          </RequiredMessagePara>
                        )}
                      </div>
                    )}
                    {parseInt(platformCountryId, 10) === 1 && (
                      <TextInput
                        id="add-enquiry-purchaseOrder"
                        type="text"
                        label={t("ENQUIRY_PURCHASE_ORDER")}
                        isFloat
                        value={String(formData.purchaseOrder.value)}
                        onChange={(e) => onPurchaseOrderChange(e)}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.purchaseOrder.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.purchaseOrder.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        error={formData.purchaseOrder.error}
                        placeholder={t("ENQUIRY_PURCHASE_ORDER")}
                      />
                    )}
                  </GridRow>
                  <GridRow column="1fr 1fr 1fr">
                    {parseInt(categoryId, 10) === 2 && (
                      <TextInput
                        id="add-enquiry-price"
                        type="text"
                        label={t("ENQUIRY_REQUESTED_PRICE")}
                        isFloat
                        disabled={isEditStep}
                        value={String(formData.price.value)}
                        onChange={(e) => onPriceChange(e)}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.price.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.price.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        error={formData.price.error}
                        placeholder={t("ENQUIRY_REQUESTED_PRICE")}
                      />
                    )}
                    {parseInt(categoryId, 10) !== 4 && (
                      <TextInput
                        id="add-enquiry-loadsPerDay"
                        type="text"
                        label={t("ENQUIRY_LOADS_PER_DAY")}
                        isFloat
                        disabled={isEditStep}
                        value={String(formData.loadsPerDay.value)}
                        onChange={(e) => onLoadsPerDayChange(e)}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.loadsPerDay.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.loadsPerDay.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        error={formData.loadsPerDay.error}
                        placeholder={t("ENQUIRY_LOADS_PER_DAY")}
                      />
                    )}
                    {parseInt(categoryId, 10) === 2 &&
                      formData.service.value === "DELIVERY" && (
                        <DropdownWithSearch
                          placeholder={t("MATERIALS_INFORMATION")}
                          label={t("MATERIALS_INFORMATION")}
                          disabled={isEditStep}
                          value={formData.materialUsages.value}
                          options={materialUsageList}
                          isMulti={false}
                          error={formData.materialUsages.error}
                          onChange={onUsageChange}
                          labelStyles={
                            formData.materialUsages.error !== ""
                              ? labelStylesError
                              : labelStyles
                          }
                          inputClass={
                            formData.materialUsages.error !== ""
                              ? "dropdown-with-search__dropdown-input-error"
                              : "dropdown-with-search__dropdown-input"
                          }
                        />
                      )}
                  </GridRow>
                  <GridRow column="1fr 1fr">
                    <TextInput
                      id="add-enquiry-complementaryAnalysis"
                      type="text"
                      label={t("ENQUIRY_COMPLEMENTARY_ANALYSIS")}
                      isFloat
                      disabled={isEditStep}
                      value={String(formData.complementaryAnalysis.value)}
                      onChange={(e) => onComplementaryAnalysisChange(e)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.complementaryAnalysis.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.complementaryAnalysis.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.complementaryAnalysis.error}
                      placeholder={t("ENQUIRY_COMPLEMENTARY_ANALYSIS")}
                    />
                    {parseInt(categoryId, 10) === 1 &&
                      parseInt(formData.subCategory.value, 10) === 2 && (
                        <MarginDiv
                          className="status__filters-wrapper"
                          marginInfo="margin-left:20px;"
                        >
                          <Image
                            className="add-enquiry__image-icon"
                            src={
                              formData.isEligibleBackfilling.value
                                ? enableIcon
                                : disableIcon
                            }
                            onClick={onEligibleBackfillingChange}
                          />{" "}
                          <ContainerLabel color="#696969">
                            {t("ENQUIRY_BACKFILLING_ELIGIBILITY_CHOICE")}
                          </ContainerLabel>
                        </MarginDiv>
                      )}
                  </GridRow>
                  <GridRow column="1fr">
                    <ContainerLabel>
                      {t("ENQUIRY_HESUS_INFORMATION")}
                    </ContainerLabel>
                  </GridRow>
                  <GridRow column="1fr">
                    <CKEditorText
                      disabled={isEditStep}
                      descriptionData={internalComment}
                      setDescriptionData={setInternalComment}
                    />
                    {formData.internalComment.error && (
                      <RequiredMessagePara>
                        {formData.internalComment.error}
                      </RequiredMessagePara>
                    )}
                  </GridRow>
                  <GridRow column="1fr">
                    <ContainerLabel>
                      {t("ENQUIRY_POLLUTION_INFORMATION")}
                    </ContainerLabel>
                  </GridRow>
                  <GridRow column="1fr">
                    <CKEditorText
                      disabled={isEditPollutionStep}
                      descriptionData={pollutionComment}
                      setDescriptionData={setPollutionComment}
                    />
                    {formData.pollutionComment.error && (
                      <RequiredMessagePara>
                        {formData.pollutionComment.error}
                      </RequiredMessagePara>
                    )}
                  </GridRow>
                  <DocumentUploadWithType
                    isEditMode={isEditMode}
                    setFormData={setFormData}
                    formData={formData}
                    selectedProduct={selectedEnquiry}
                    existingDocuments={existingDocuments}
                    setExistingDocuments={setExistingDocuments}
                    setDocType={setDocType}
                    docType={docType}
                    documentTypeOptions={enquiryDocumentTypes}
                  />
                </div>
              </SectionContainer>
            </FlexRow>
          </OuterWrapper>
        </FormBody>

        <ButtonWrapper>
          {createEnquiryAPIError && <div>{createEnquiryAPIError}</div>}
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {isEnquiryCreating && <ClipLoader size={15} color="#fff" />}
              {!isEnquiryCreating && t("SUBMIT")}
            </>
          </Button>

          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CLOSE")}
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditEnquiry.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  title: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  updateRefeshStatus: PropTypes.func.isRequired,
  enquiryData: PropTypes.object,
  leadId: PropTypes.number,
};

AddEditEnquiry.defaultProps = {
  id: null,
  isEditMode: false,
  enquiryData: null,
  leadId: null,
};
export default withTranslation()(AddEditEnquiry);
